(() => {
    'use strict';

    let showLastMinCountdown = [];

    const clearFinishedNotificationTimeout = widget => {
        const timeoutId = widget.data('finished-notification-timeout-id');
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
            widget.removeData('finished-notification-timeout-id');
        }
    };

    const hideTime = (widget, elems) => {
        const options = {
            width: 0,
            opacity: 0,
            paddingLeft: 0,
            paddingRight: 0
        };
        elems.addClass('hiding').css('overflow', 'hidden').velocity(options, {
            duration: howspace.getAnimationDuration(widget, '--howspace-animation-350'),
            complete: () => {
                elems.removeClass('hiding').addClass('d-none').removeAttr('style');
            }
        });
    };

    const showTime = (widget, elems) => {
        elems.each(function () {
            const elem = $(this);
            elem.removeClass('d-none');
            const animWidth = elem.outerWidth();

            const options = {
                width: animWidth,
                opacity: 1
            };
            elem.css({ width: 0, opacity: 0 }).velocity(options, {
                duration: howspace.getAnimationDuration(widget, '--howspace-animation-350'),
                complete: () => {
                    elem.removeAttr('style');
                }
            });
        });
    };

    const unitsArray = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'];

    const getDaysInMonthBefore = (year, monthIndex) => new Date(Date.UTC(year, monthIndex, 0)).getUTCDate();

    // Mirrors PHP DateTime::diff, which produces the values already rendered into the markup. Months and years are
    // calendar units, so decomposing with fixed lengths would drift from the server side numbers.
    const getCalendarDiff = (from, to) => {
        if (to <= from) {
            return { years: 0, months: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
        }

        let seconds = to.getUTCSeconds() - from.getUTCSeconds();
        let minutes = to.getUTCMinutes() - from.getUTCMinutes();
        let hours = to.getUTCHours() - from.getUTCHours();
        let days = to.getUTCDate() - from.getUTCDate();
        let months = to.getUTCMonth() - from.getUTCMonth();
        let years = to.getUTCFullYear() - from.getUTCFullYear();

        if (seconds < 0) {
            seconds += 60;
            minutes--;
        }
        if (minutes < 0) {
            minutes += 60;
            hours--;
        }
        if (hours < 0) {
            hours += 24;
            days--;
        }

        // Borrow whole calendar months, walking backwards from the month of the target date.
        let monthsBack = 0;
        while (days < 0) {
            monthsBack++;
            days += getDaysInMonthBefore(to.getUTCFullYear(), to.getUTCMonth() - monthsBack + 1);
            months--;
        }

        while (months < 0) {
            months += 12;
            years--;
        }

        return { years, months, days, hours, minutes, seconds };
    };

    const updateTimer = widget => {
        if (!widget) {
            // Widget is not available anymore.
            return;
        }

        const endDate = widget.data('end-date');

        if (!endDate || !(endDate instanceof Date)) {
            // Widget does not have proper end date data attribute.
            return;
        }

        // Derive the displayed units and the finish check from the same whole second count, otherwise the last tick
        // can render 00:01 and stop the interval in the same pass.
        const seconds = Math.max(0, Math.ceil((endDate.getTime() - Date.now()) / 1000));
        const diff = getCalendarDiff(new Date(endDate.getTime() - seconds * 1000), endDate);

        unitsArray.forEach(unit => {
            // Update DOM only if the value has changed and the unit element is visible.
            let timeLeft = parseInt(diff[unit]);
            const timeLeftElem = widget.find('.' + unit + '-left');
            if (timeLeftElem.is(':visible') && parseInt(timeLeftElem.text()) !== timeLeft) {
                // If the time left is less than 0, then set it to 0.
                timeLeft = Math.max(0, timeLeft);
                timeLeftElem.text(real.pad(timeLeft));
            }
        });

        // Show the notification if the countdown is 1 minute or less.
        if (seconds <= 60 && seconds > 0) {
            const timerContent = `
                <div class="timer-content grid center gap-0" data-widget-id="${widget.data('widget-id')}">
                    ${widget.find('.timer-content').html()}
                </div>
            `;

            const notificationContent = `
                ${timerContent}
                <button id="notification-bar-close-btn" class="d-flex justify-content-center align-items-center">
                    <i class="fa-light fa-xmark"></i>
                </button>
            `;

            if ($('#real-notification-bar-content .timer-content').length > 0) {
                $('#real-notification-bar-content .timer-content').replaceWith(timerContent);
            } else if (showLastMinCountdown[widget.data('widget-id')]) {
                const notificationBar = real.notification.show(notificationContent);
                // Remove the role="alert" because this is countdown
                notificationBar.find('#real-notification-bar-content').removeAttr('role');
                $('#real-notification-bar').addClass('has-timer-content');
                notificationBar.on(real.notification.STARTING_TO_SHOW_NEW_CONTENT, () => {
                    notificationBar.find('#notification-bar-close-btn:not(#real-notification-bar-content #notification-bar-close-btn)').addClass('d-none');
                    $('#real-notification-bar').find('#real-notification-bar-content #notification-bar-close-btn:visible').on('click', real.notification.hide);
                });
            }
        }

        if (seconds <= 0) {
            clearInterval(widget.data('update-timer-interval-id'));
            widget.dataAndAttr('is-countdown-finished', true);
            widget.dataAndAttr('is-countdown-started', false);

            widget.find('.timer-buttons').addClass('d-none');

            if (widget.find('.timer-time-is-up-content').html()?.trim() !== '' && widget.data('is-countdown-finished')) {
                widget.find('.timer-time-is-up-content').removeClass('d-none');
            }

            // Assign the content of the timer to the notification bar.
            const notificationBar = real.notification.show(widget.find('.timer-time-is-up-text').html());
            notificationBar.on(real.notification.STARTING_TO_SHOW_NEW_CONTENT, () => {
                notificationBar.find('#real-notification-bar-content').attr('role', 'alert');
                notificationBar.find('#notification-bar-close-btn:not(#real-notification-bar-content #notification-bar-close-btn)').removeClass('d-none');
            });

            // Close the notification bar after 15 second if the countdown is finished and the notification bar is visible.
            const timeoutId = setTimeout(() => {
                widget.removeData('finished-notification-timeout-id');
                if (showLastMinCountdown[widget.data('widget-id')] && $('#real-notification-bar-content').is(':visible')) {
                    real.notification.hide();
                }
            }, 15000);
            widget.data('finished-notification-timeout-id', timeoutId);

            showLastMinCountdown[widget.data('widget-id')] = true;
            return;
        }

        real.loop(unitsArray, unit => {
            // Hide the leftmost time unit DOM elements if the value turns into zero.
            const timeLeft = parseInt(diff[unit]);
            if (timeLeft > 0) {
                return false;
            }

            const elems = widget.find('.' + unit + '-content:visible');
            if (elems.length === 0) {
                return;
            }

            const visibleTimeUnitElems = widget.find('.countdown-number:visible:not(.hiding)');
            if (visibleTimeUnitElems.length <= 2) {
                return;
            }

            hideTime(widget, elems);

            // Check if we need to show the next unit DOM elements.
            if (widget.find('.countdown-number:visible:not(.hiding)').length < 3) {
                const separator = widget.find('.countdown-number:visible').last().next('.countdown-separator');
                if (separator.length > 0) {
                    const index = separator.index();
                    const elems = widget.find(`[data-col="${index + 1}"], [data-col="${index + 2}"]`);
                    showTime(widget, elems);
                    updateTimer(widget);
                }
            }
        });
    };

    const startCountdown = (widget) => {
        clearFinishedNotificationTimeout(widget);
        const secondRemaining = widget.data('seconds-remaining');
        const endDate = new Date(Date.now() + (secondRemaining * 1000));
        widget.dataAndAttr('end-date', endDate);
        // Intervals are unreliable, thus we call the updateTimer function once per 200ms for a smoother experience.
        // The values and UI will update only once per second.
        widget.dataAndAttr('update-timer-interval-id', setInterval(() => {
            updateTimer(widget);
        }, 200));
        updateTimer(widget);
    };

    real.events.on('timer:started', notification => {
        const widget = $('#widget-' + notification.object.widget.id);
        if (widget.length === 0) {
            // No widget found from the DOM.
            return;
        }

        widget.dataAndAttr('is-countdown-started', true);
        startCountdown(widget);

        widget.find('.start-countdown-btn').addClass('d-none');
        widget.find('.pause-countdown-btn').removeClass('d-none');
        widget.find('.reset-countdown-btn').removeClass('d-none');
    });

    real.events.on('timer:paused', notification => {
        const widget = $('#widget-' + notification.object.widget.id);
        if (widget.length === 0) {
            // No widget found from the DOM.
            return;
        }

        widget.dataAndAttr('is-countdown-started', false);
        clearInterval(widget.data('update-timer-interval-id'));

        widget.find('.pause-countdown-btn').addClass('d-none');
        widget.find('.start-countdown-btn').removeClass('d-none');
        widget.find('.reset-countdown-btn').removeClass('d-none');
    });

    const startOrStopCountdown = (btn, flag) => {
        const widget = btn.closest('.widget');
        const widgetId = widget.data('widget-id');

        real.button.loading(btn, widget.find('.widget-view-content'));

        const dataPayload = {
            countdown_started: flag
        };

        real.ajax.json(real.baseUri + '/api/widget/timer/' + widgetId, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: response => {
                real.button.reset(btn, widget.find('.widget-view-content'));
                if (!flag && response.timer?.countdown_seconds) {
                    widget.dataAndAttr('seconds-remaining', response.timer.countdown_seconds);
                }
            },
            error: () => {
                real.button.reset(btn, widget.find('.widget-view-content'));
            }
        });
    };

    const resetCountdown = btn => {
        const widget = btn.closest('.widget');
        const widgetId = widget.data('widget-id');

        real.button.loading(btn, widget.find('.widget-view-content'));

        const dataPayload = {
            countdown_reset: true
        };

        real.ajax.json(real.baseUri + '/api/widget/timer/' + widgetId, {
            type: 'POST',
            data: JSON.stringify(dataPayload),
            success: () => {
                real.button.reset(btn, widget.find('.widget-view-content'));
            },
            error: () => {
                real.button.reset(btn, widget.find('.widget-view-content'));
            }
        });
    };

    howspace.widgets.timer = {
        initView: widget => {
            if (widget.data('is-countdown-started')) {
                startCountdown(widget);
            }

            widget.find('.start-countdown-btn').on('click', e => {
                startOrStopCountdown($(e.target), true);
            });

            widget.find('.pause-countdown-btn').on('click', e => {
                startOrStopCountdown($(e.target), false);
            });

            widget.find('.reset-countdown-btn').on('click', e => {
                resetCountdown($(e.target));
            });

            const widgetId = widget.data('widget-id');
            showLastMinCountdown[widgetId] = true;
            real.dom.$body.on('click', '#real-notification-bar #notification-bar-close-btn', () => {
                if ($('#real-notification-bar-content .timer-content[data-widget-id="' + widget.data('widget-id') + '"]').length > 0) {
                    showLastMinCountdown[widgetId] = false;

                }
            });
        },
        destroyView: widget => {
            clearFinishedNotificationTimeout(widget);
            const intervalId = widget.data('update-timer-interval-id');
            if (intervalId) {
                clearInterval(intervalId);
            }

            if ($('#real-notification-bar .timer-content').length > 0) {
                real.notification.hide();
                showLastMinCountdown[widget.data('widget-id')] = false;
            }
        },
        initEdit: widget => {
            widget.find('input[min]').on('blur input change', real.input.validateMin);
            widget.find('input[max]').on('blur input change', real.input.validateMax);
        },
        destroyEdit: widget => {
        },
        save: (widget, dataPayload) => {
            if (widget.find('.countdown-mode-radio:checked').val() === 'time') {
                dataPayload.countdown_until_date = null;
                dataPayload.countdown_seconds = parseFloat(widget.find('.countdown-hours-input').val()) * 3600;
                dataPayload.countdown_seconds += parseFloat(widget.find('.countdown-minutes-input').val()) * 60;
                dataPayload.countdown_seconds += parseFloat(widget.find('.countdown-seconds-input').val());
            } else {
                dataPayload.countdown_seconds = 0;
            }
            return dataPayload;
        }
    };

})();
